import {createContext, useContext} from "react";

const BusinessContactContext = createContext(null);

export const useBusinessContactContext = () =>
  useContext(BusinessContactContext);

export default BusinessContactContext;
